export default "__VITE_ASSET__DptCMOBr__"